export const skills = [
  {
    programLanguage: "Python",
    solidCircle: 4,
    regularCircle: 1,
  },
  {
    programLanguage: "MySQL",
    solidCircle: 4,
    regularCircle: 1,
  },
  {
    programLanguage: "PHPL",
    solidCircle: 3,
    regularCircle: 2,
  },
  {
    programLanguage: "R",
    solidCircle: 3,
    regularCircle: 2,
  },
  {
    programLanguage: "C",
    solidCircle: 3,
    regularCircle: 2,
  },
];
